import axios from 'axios'

const config = {
  headers: {
    'Content-Type': 'application/json'
  }
}

const getters = {
  PROV_LIST: state => state.providers,
  PROV_INFO: state => state.provInfo,
}
const mutations = {
  SET_PROV_LIST: (state, payload) => {
    state.providers = payload.data
  },
  SET_PROV_INFO: (state, payload) => {
    state.provInfo = payload.data
  },
}
const actions = {
  GET_PROV_LIST: async (context, payload) => {
    const { data } = await axios.post('/wallet/providers/list', payload, config)
    if (data !== undefined && data.status == 1) {
      context.commit('SET_PROV_LIST', data)
    }
    return data
  },
  GET_PROV_INFO: async (context, payload) => {
    const { data } = await axios.post('/wallet/providers/info', payload, config)
    if (data !== undefined && data.status == 1) {
      context.commit('SET_PROV_INFO', data)
    }
    return data
  },
}

export default {
  state: () => ({
    providers: null,
    provInfo: null
  }),
  mutations,
  actions,
  getters
}
